import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  is_loaded: false,
  amz_country: "",
  amz_access_key: "",
  amz_secret_key: "",
  amz_tracking_id: "",
  ebay_dev_id: "",
  ebay_cert_id: "",
  ebay_app_id: "",
  ebay_country: "",
  ebay_user_id: "",
  ebay_camp_id: "",
};

const ApiKeySlice = createSlice({
  name: "api_keys",
  initialState,
  reducers: {
    setApiKeys(state, action) {
      if (action.payload.type === "amazon") {
        console.log("Calling", action);

        state.amz_country = action.payload.amz_country;
        state.amz_access_key = action.payload.amz_access_key;
        state.amz_secret_key = action.payload.amz_secret_key;
        state.amz_tracking_id = action.payload.amz_tracking_id;
      } else if (action.payload.type === "ebay") {
        console.log("Calling Ebay");
        state.ebay_dev_id = action.payload.ebay_dev_id;
        state.ebay_app_id = action.payload.ebay_app_id;
        state.ebay_country = action.payload.ebay_country;
        state.ebay_user_id = action.payload.ebay_user_id;
        state.ebay_cert_id = action.payload.ebay_cert_id;
        state.ebay_camp_id = action.payload.ebay_camp_id;
      }
      state.is_loaded = action.payload.is_loaded;
    },
  },
});

export const apiAction = ApiKeySlice.actions;
export default ApiKeySlice.reducer;
